var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlechaArriba(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "up-arrow-above-raise-high",
    style: {
      enableBackground: "new 0 0 8.706 15.698"
    },
    viewBox: "0 0 8.706 15.698",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "8.706,4.344 4.353,0 0,4.344 0.706,5.052 3.853,1.912 3.853,15.698 4.853,15.698 4.853,1.912 8,5.052 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechaArriba);
export default __webpack_public_path__ + "static/media/flecha_arriba.0a5f87f53c88b858a3cff17f41a281c6.svg";
export { ForwardRef as ReactComponent };